import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import List from '@mui/material/List';
import { default as ListItem } from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { useEffect, useState } from 'react';
import './CRFstyles.scss';
// import { useCRFForms } from './useCRFForms';
import clsx from 'clsx';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useCRFForms } from '../../CRFForms/useCRFForms';

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    border: `0px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    }
  })
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ChevronRightIcon sx={{ fontSize: '1.6rem' }} />} {...props} />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '0px solid rgba(0, 0, 0, .125)'
}));

function CRFVisitEventsMenu({
  visitsData,
  setselectedVisit,
  selectedVisit,
  setmodifiedFormConfig,
  seteditRowData,
  editRowData,
  bookMarkField
}: any) {
  const [currentVisitId, setVisitId] = useState(null);
  const [currentEventtId, setcurrentEventtId] = useState(null);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [clonedvisitsData, setvisitsData] = useState<any>(null);
  const { getCheckboxValue, getRadioButtonValue } = useCRFForms();

  useEffect(() => {
    if (selectedVisit) {
      setVisitId(selectedVisit.study_visit.id);
    }
  }, []);

  useEffect(() => {
    if (visitsData) {
      const clonedData = visitsData.map((item: any) => {
        const sortedCrfsData = [...item.crf_data];
        sortedCrfsData.sort((a: any, b: any) => a.result.event_number - b.result.event_number);
        return { ...item, crf_data: sortedCrfsData };
      });
      setvisitsData(clonedData);
    }
  }, [visitsData]);

  useEffect(() => {
    if (editRowData) {
      setcurrentEventtId(editRowData.id);
    }
  }, [editRowData]);

  const handleChangeEventData = (visit: any, data: any) => {
    setVisitId(visit.study_visit.id);
    setselectedVisit(visit);
    const clonedObj = JSON.parse(JSON.stringify(visit.visit_crf));
    clonedObj.update = true;
    seteditRowData(data);
    setmodifiedFormConfig(clonedObj);
  };
  return (
    <div style={{ overflow: 'auto', maxHeight: 'calc(100vh - 104px)' }} className="fullModalAccordionWrap">
      {clonedvisitsData && clonedvisitsData.length > 0
        ? clonedvisitsData.map((item: any, sindex: number) => {
            return (
              <Accordion expanded={currentVisitId == item.study_visit.id} key={`clonedvisitsData${sindex}`}>
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id={item.study_visit.id}
                  onClick={() => setVisitId(item.study_visit.id)}
                >
                  <Typography>
                    <strong>{item?.unscheduled_visit ?? item?.study_visit?.protocol_visit_name}</strong>
                  </Typography>
                  <Typography variant="body2" className="acc_Date">
                    {item?.study_visit?.visit_date &&
                      moment(item?.study_visit?.visit_date).format(`${userPreferedDateFormat?.toUpperCase()}`)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List className="accordionStyles">
                    {item.crf_data && item.crf_data.length > 0
                      ? item.crf_data.map((obj: any, dIndex: number) => {
                          return (
                            <ListItem
                              key={`itemcrf_data${dIndex}`}
                              className={clsx([
                                currentEventtId == obj.result.id ? 'selected' : '',
                                obj.result.event_status == 'Deleted' ? 'disableDeletedCRFEvent' : ''
                              ])}
                              onClick={() => handleChangeEventData(item, obj.result)}
                            >
                              <div className="body3"># {obj.result.event_number}</div>
                              <div className="body2">
                                {obj?.result?.bookmark_key_value
                                  ? typeof obj?.result.bookmark_key_value === 'object' &&
                                    'key' in obj.result.bookmark_key_value
                                    ? obj?.result?.bookmark_key_value?.key.map((value: any) => value?.label).toString()
                                    : typeof obj?.result.bookmark_key_value === 'object'
                                    ? obj?.result?.bookmark_cmp?.cmp == 'checkbox'
                                      ? getCheckboxValue(obj?.result?.bookmark_cmp, obj?.result?.bookmark_key_value)
                                      : obj?.result?.bookmark_key_value?.label
                                    : obj?.result?.bookmark_cmp?.cmp == 'radio'
                                    ? getRadioButtonValue(obj?.result?.bookmark_cmp, obj?.result?.bookmark_key_value)
                                    : obj?.result?.bookmark_key_value.toString()
                                  : obj?.result && obj?.result?.bookmark_cmp.fieldKey == 'label'
                                  ? obj?.result?.bookmark_cmp.title
                                  : null}
                              </div>
                              <div className="body2">
                                {moment(obj.result.date_of_entry).format(`${userPreferedDateFormat.toUpperCase()}`)}{' '}
                              </div>
                            </ListItem>
                          );
                        })
                      : null}
                  </List>
                </AccordionDetails>
              </Accordion>
            );
          })
        : null}
    </div>
  );
}

export default CRFVisitEventsMenu;
